var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene-view"},[_c('div',{ref:"engineContainer",staticClass:"engine-container",style:(`visibility:${_vm.canvasVisible ? 'visible' : 'hidden'}`),attrs:{"id":"engineContainer"}}),(_vm.showpercentage)?_c('loading',{attrs:{"percentage":_vm.percentage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }